<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="title-heading d-flex justify-content-between">
          <h1>{{ $static('s-t.title', 'Фільтр по тегам') }}</h1>
        </div>

        <div class="default-cards-list minimal-list">
          <div class="default-cards-top">
            <div class="name name-category">{{ $static('s-o.tagname', 'Назва тегу') }}</div>
            <div class="name name-actions">{{ $static('s-t.actions', 'Виконати дії') }}</div>
          </div>
          <div class="default-card-layout">
            <div class="default-card-content">
              <div class="default-card-main">
                <div class="default-card-title">{{ $static('s-o.tagname', 'Назва тегу') }}</div>
              </div>
              <div class="actions-box">

                <Popper arrow :content="$static('iconsbtn.edit', 'Редагувати')" hover placement="top"
                  style="white-space: nowrap">
                  <button class=" btn-icon btn-rounded btn-icon-transparent editor_trigger">
                    <span class="icon icon-edit"></span>
                  </button>
                </Popper>
                <Popper arrow :content="$static('iconsbtn.copy', 'Дублювати')" hover placement="top"
                  style="white-space: nowrap">
                  <button class="btn-icon btn-rounded btn-icon-transparent editor_trigger">
                    <span class="icon icon-3copy3"></span>
                  </button>
                </Popper>
                <Popper arrow :content="$static('iconsbtn.delete', 'Видалити')" hover placement="top"
                  style="white-space: nowrap">
                  <a href="#" class="btn-icon btn-rounded btn-icon-transparent btn-remove">
                    <span class="icon icon-trash"></span>
                  </a>
                </Popper>

              </div>
            </div>
          </div>
          <div class="default-card-layout">
            <div class="default-card-content">
              <div class="default-card-main">
                <div class="default-card-title">Назва тегу</div>
              </div>
              <div class="actions-box">
                <Popper arrow :content="$static('iconsbtn.edit', 'Редагувати')" hover placement="top"
                  style="white-space: nowrap">
                  <button class=" btn-icon btn-rounded btn-icon-transparent editor_trigger">
                    <span class="icon icon-edit"></span>
                  </button>
                </Popper>
                <Popper arrow :content="$static('iconsbtn.copy', 'Дублювати')" hover placement="top"
                  style="white-space: nowrap">
                  <button class="btn-icon btn-rounded btn-icon-transparent editor_trigger">
                    <span class="icon icon-3copy3"></span>
                  </button>
                </Popper>
                <Popper arrow :content="$static('iconsbtn.delete', 'Видалити')" hover placement="top"
                  style="white-space: nowrap">
                  <a href="#" class="btn-icon btn-rounded btn-icon-transparent btn-remove">
                    <span class="icon icon-trash"></span>
                  </a>
                </Popper>

              </div>
            </div>
          </div>
        </div>
        <button @click="openEditor">editor</button>
      </div>
    </div>

    <Teleport to="body">
      <!-- EDITOR WRAPPER-->
      <div class="overlay-editor item-editor">
        <div class="overlay-editor-wrapper">
          <div class="panel-top">

            <div class="lang-selector-holder d-flex align-items-center">
              <label v-if="langs && langs.length > 1" class="custom-label">{{ $static('ei.tr', 'Переклад на:') }}</label>
              <LangSelector v-model="lang" />
            </div>

            <a href="javascript:void(0);" class="back_trigger" @click="cancel">
              <span class="icon icon-cross"></span>
            </a>
          </div>
          <div class="panel-middle">
            <h3 class="panel-top-name">{{ $static('s-t.tagedit', 'Редагування тегу') }}</h3>
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <div class="custom-label">{{ $static('s-o.tagname', 'Назва тегу') }}</div>
                  <input type="text" class="form-control custom-input">
                </div>
              </div>
            </div>
          </div>
          <div class="panel-bottom">
            <button class="transparent-btn default-btn back_trigger" @click="cancel">
              <span class="text">{{ $static('ei.cancel', 'Скасувати') }}</span>
            </button>
            <button class="default-btn btn-accent" @click="save">
              <span class="text">{{ $static('ei.save', 'Зберегти зміни') }}</span>
            </button>
            <button class="default-btn btn-red">
              <span class="text">{{ $static('ei.delete', 'Видалити') }}</span>
            </button>
          </div>
        </div>
      </div>
      <!--END EDITOR WRAPPER-->
    </Teleport>

  </div>
</template>

<script>
import api from '@/api'
import { Chrome } from '@lk77/vue3-color'
import LangSelector from '../components/LangSelector';
import OptionEditor from '../components/OptionEditor';
import OptionEditorFull from '../components/OptionEditorFull';
// import { Chrome } from 'vue-color'

export default {
  name: 'Tags',
  components: {},
  data() {
    return {}
  },
  computed: {
    langs() {
      return this.$store.getters.settings
        && this.$store.getters.settings.public
        && this.$store.getters.settings.public.lang
        && Array.isArray(this.$store.getters.settings.public.lang) ?
        this.$store.getters.settings.public.lang : []
    },
  },
  mounted() {

  },
  methods: {
    cancel() {
      window.$('body').removeClass('is-hidden');
      window.$('body > .active').removeClass('active');
    },
    openEditor(item, event) {
      // window.$(event.target).toggleClass('open');
      window.$('.filter_sidebar').removeClass('active');
      window.$('body').addClass('is-hidden');

      window.$('.back-blur').toggleClass('active');
      window.$('.overlay-editor.item-editor').toggleClass('active');
    },
  }
}
</script>

<style scoped></style>